import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_PATH} from '../../metamodel/Concept';

export default class PathNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_PATH;
	}
}
